import { bunja } from 'bunja';
import { addHours, isAfter, parseISO } from 'date-fns';
import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';

import { getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

import { kycBunja } from '../../../kyc';

export const KYC_MODAL_HIDE_TIMESTAMP_KEY = 'flipster.configs.v1.kycModalHideTimestamp';

export const kycReminderBunja = bunja(() => {
  const { kycStatusAtom, isLoadingAtom } = bunja.use(kycBunja);

  const kycModalHideTimestampBaseAtom = atomWithDefault<string | null>(() => {
    return getLocalStorage(KYC_MODAL_HIDE_TIMESTAMP_KEY);
  });

  const kycModalHideTimestampAtom = atom(
    (get) => get(kycModalHideTimestampBaseAtom),
    (_, set, timestamp: string) => {
      setLocalStorage(KYC_MODAL_HIDE_TIMESTAMP_KEY, timestamp);
      set(kycModalHideTimestampBaseAtom, timestamp);
    },
  );

  const isShowKycPopupAtom = atom((get) => {
    const kycStatus = get(kycStatusAtom);
    if (!kycStatus?.gracePeriod) return false;

    // 모달은 닫은 시각으로부터 24시간이 지나지 않은 경우 노출하지 않는다
    const hideTimeStamp = get(kycModalHideTimestampAtom);
    if (hideTimeStamp) {
      const nextShowTime = addHours(parseISO(hideTimeStamp), 24);
      const currentTime = new Date();

      if (isAfter(nextShowTime, currentTime)) return false;
    }

    return true;
  });

  return { kycStatusAtom, isLoadingKycStatusAtom: isLoadingAtom, isShowKycPopupAtom, kycModalHideTimestampAtom };
});
kycReminderBunja.debugLabel = 'kycReminderBunja';
